import React, { useEffect, useRef, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { fetchDoctorProfile, imageBaseUrl, registerUser, updateDoctorDetails, updateUserDetais } from "../../constants/ApiConstants";
import { Link, Navigate, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateDoctorData, updateUserData } from "../../store/appSlice";
import { FaCirclePlus } from "react-icons/fa6";
import TextAreaField from "../../components/TextAreaField";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function DoctorProfileSetupOne() {
  pageTitle("Complete Profile Registration");

  const [loading, setLoading] = useState(false);
  const doctorData = useSelector((state) => state.appSlice.doctorData);
  const settings = useSelector((state) => state.appSlice.settings);
  const [image, setImage] = useState(null);
  const [designation, setDesigntation] = useState("");
  const [degree, setDegree] = useState("");
  const [langs, setLangs] = useState("");
  const [yearsOfExp, setYearOfExp] = useState("");
  const [consultationFees, setConsultationFees] = useState("");
  const imageRef = useRef();

  const [imagePreview, setImagePreview] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // if (doctorData.image && doctorData.designation && doctorData.degrees && doctorData.experience_year && doctorData.consultation_fee) {
  //   return <Navigate to="/doctor-profile" />;
  // }

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);

    axiosInstance
      .post(fetchDoctorProfile, { doctor_id: doctorData?.id })
      .then((res) => {
        setDegree(res?.data?.data?.degrees || "");
        setDesigntation(res?.data?.data?.designation || "");
        setImagePreview(res?.data?.data?.image ? `${imageBaseUrl}${res?.data?.data?.image}` : null);
        setLangs(res?.data?.data?.languages_spoken || "");
        setYearOfExp(res?.data?.data?.experience_year || "");
        setConsultationFees(res?.data?.data?.consultation_fee || "");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmitClick = async () => {
    if (!imagePreview) {
      toast.error("Image is required");
      return;
    }

    if (designation === "") {
      toast.error("Designation is required");
      return;
    }

    if (degree === "") {
      toast.error("Please provide Degrees");
      return;
    }
    if (langs === "") {
      toast.error("Please provide Languages");
      return;
    }
    if (consultationFees === "" || consultationFees == 0) {
      toast.error("Please provide Consulation Fee");
      return;
    }
    const formdata = new FormData();
    formdata.append("doctor_id", doctorData?.id);
    if (image && image instanceof File) {
      formdata.append("image", image);
    }
    formdata.append("designation", designation);
    formdata.append("degrees", degree);
    formdata.append("languages_spoken", langs);
    formdata.append("experience_year", yearsOfExp);
    formdata.append("consultation_fee", consultationFees);
    try {
      setLoading(true);
      const response = await axiosInstance.post(updateDoctorDetails, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigate("/doctor-profile");
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  const onImageClick = (event) => {
    imageRef.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(file);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Wrapper>
      <Section topMd={60} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center">
          <div className="col-12 col-md-4 g-2 mx-auto">
            <CommonMobileHeader title={"Complete Registration"} />
            <p className="fs-md text-grey2 p-2"></p>
            <div className="col-6">
              <button type="button" onClick={onImageClick} className="bg-grey2 img-thumbnail d-flex justify-content-center align-items-center mb-3 rounded mt-3 position-relative" style={{ height: "100px", width: "100px", cursor: "pointer" }}>
                <input type="file" hidden accept="image/*" ref={imageRef} onChange={handleImageChange} />
                {imagePreview && <img className="h-100 w-100" src={imagePreview} style={{ objectFit: "cover" }} />}
                <FaCirclePlus color="gray" size={24} className="position-absolute top-45 inset-0 z-2" />
              </button>
            </div>
            <InputField label="Designation (EG: Senior Pediatric Surgeon)" placeholder="Enter designation" inputType={"text"} value={designation} onChange={(e) => setDesigntation(e.target.value)} />
            <InputField label="Enter your Degrees (Separated by ( , )" sublabel="Example MS (General Surgery) from AIMS, BC nagara" placeholder="Enter degrees" inputType={"text"} value={degree} onChange={(e) => setDegree(e.target.value)} />
            <TextAreaField rows={3} label="Languages You Speak : Separated by ( , )" sublabel="Example MS (General Surgery) from AIMS, BC nagara" placeholder="Bengali, Hindi, English" inputType={"text"} value={langs} onChange={(e) => setLangs(e.target.value)} />
            <InputField label="Years of Experience" sublabel={"Example: Hindi, English, French"} placeholder="Enter years of experience" inputType={"numeric"} value={yearsOfExp} onChange={(e) => setYearOfExp(e.target.value)} />
            <span className="fs-normal d-block text-grey1">Consultation Fees</span>
            <span className="fs-sm d-block text-grey2">You can change this later whenever you want.</span>
            <div className="d-flex bg-grey2 w-100 align-items-center rounded mb-2">
              <div className="text-center d-flex justify-content-center align-items-center rounded" style={{ background: "#e4e4e4", width: "36px", height: "36px" }}>
                <strong className="text-center text-black">{settings.currency}</strong>
              </div>
              <input type="number" className="w-75 py-2 px-3 border-0 bg-transparent" value={consultationFees} onChange={(e) => setConsultationFees(e.target.value)} />
            </div>
            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={loading} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
